import {FC} from 'react'
import {useTranslation} from 'react-i18next'

interface BadgeColorSIPProps {
  status: number
  text: string
  type: string
}

export const BadgeColorSIP: FC<BadgeColorSIPProps> = ({text, status, type}) => {
  const {t} = useTranslation()

  const handleStatusSigning = (status: string) => {
    let text = status?.split(' ') ?? []
    let newStatus = t('waiting for signing ID').replace('#ID', text.at(3) || '-')
    return newStatus
  }

  const handleStatusWaiting = (status: string) => {
    let text = status?.split(' ') ?? []
    let newStatus = (
      text.includes('Review') ? t('Waiting for Review') : t('Waiting for Appproval')
    ).replace('#ID', text.at(3) || '-')
    return newStatus
  }
  const handleStatusProccess = (status: string) => {
    let text = status?.split(' ') ?? []
    let newStatus = (
      text.includes('Review') ? t('Process for Review') : t('Process for Appproval')
    ).replace('#ID', text.at(3) || '-')
    return newStatus
  }
  if (type === 'header') {
    return (
      <div>
        {text == 'Pengajuan Amandemen' ||
        text == 'Amandemen' ||
        text == 'Menunggu Persetujuan Amandemen' ||
        text == 'Diamandemen Customer' ||
        text == 'Telah Diamandemen' ? (
          <span className='badge badge-light-info'>{t('Amandemen')}</span>
        ) : status === 1 ? (
          <span className='badge badge-light-primary'>{handleStatusWaiting(text)}</span>
        ) : status === 2 ? (
          <span className='badge badge-light-warning'>{t(text)}</span>
        ) : status === 3 ? (
          <span className='badge badge-light-primary'>{handleStatusProccess(text)}</span>
        ) : status === 4 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 5 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 6 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 7 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 8 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 9 ? (
          <span className='badge badge-light-warning'>{t(text)}</span>
        ) : status === 10 ? (
          <span className='badge badge-light-primary'>{handleStatusSigning(text)}</span>
        ) : status === 11 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : (
          <span className='badge badge-light-danger'>{t(text)}</span>
        )}
      </div>
    )
  } else {
    return (
      <div className='mt-3'>
        {text == 'Pengajuan Amandemen' ||
        text == 'Amandemen' ||
        text == 'Menunggu Persetujuan Amandemen' ||
        text == 'Diamandemen Customer' ||
        text == 'Telah Diamandemen' ? (
          <span className='badge badge-light-info'>{t('Amandemen')}</span>
        ) : status === 1 ? (
          <span className='badge badge-light-primary'>{handleStatusWaiting(text)}</span>
        ) : status === 2 ? (
          <span className='badge badge-light-warning'>{t(text)}</span>
        ) : status === 3 ? (
          <span className='badge badge-light-primary'>{handleStatusProccess(text)}</span>
        ) : status === 4 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 5 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 6 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 7 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 8 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 9 ? (
          <span className='badge badge-light-info'>{t(text)}</span>
        ) : status === 10 ? (
          <span className='badge badge-light-primary'>{handleStatusSigning(text)}</span>
        ) : status === 11 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : (
          <span className='badge badge-light-danger'>{t(text)}</span>
        )}
      </div>
    )
  }
}
